import {
  Directive,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { SessionService } from '@utils/services/session.service';

@Directive({
  selector: '[hasPermissions]',
  standalone: true,
})
export class IfPermissionsDirective implements OnChanges {

  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly sessionService = inject(SessionService);

  private isViewCreated = false;

  @Input({ required: true }) hasPermissions!: string;
  @Input({ required: true }) hasPermissionsFor!: string[];
  @Input() hasPermissionsVisible = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['hasPermissions']
      || changes['hasPermissionsFor']
      || changes['hasPermissionsVisible']
    ) {
      this.updateView();
    }
  }

  private updateView(): void {
    const shouldShow = this.checkPermissions();

    if (shouldShow && !this.isViewCreated) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isViewCreated = true;
    } else if (!shouldShow && this.isViewCreated) {
      this.viewContainer.clear();
      this.isViewCreated = false;
    }
  }

  private checkPermissions(): boolean {
    const user = this.sessionService.user;

    if (!user) return false;

    if (user.type === 'admin') return true;

    if (this.hasPermissionsVisible) return true;

    if (!this.hasPermissionsFor?.length) return false;

    const userModule = user.permissions?.find(
      (module) => module.module === this.hasPermissions,
    );

    if (!userModule) return false;

    return this.hasPermissionsFor.some((permission) =>
      userModule.permissions.includes(permission)
    );
  }
}
